<template>
  <div class="layout">
    <div>
      <p>{{ title }}</p>
      <p>{{ subtitle }}</p>
      <p>{{ blurb }}</p>
      <p class="instruction">{{ instruction }}</p>
      <div v-if="$route.name == 'ReadTheReport'">
      </div>
      <div v-else><InputOptions :page="pageid" /></div>
    </div>
    <div class="go-back"><router-link to="/"><button>GO BACK</button></router-link></div>
  </div>
</template>

<script>

  import InputOptions from "@/components/InputOptions.vue";

  export default {
    name: "Layout",
    props: {
      pageid: String,
      title: String,
      subtitle: String,
      blurb: String,
      instruction: String
    },
    components: {
      InputOptions
    }
  };

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .layout {
    padding: 2rem;
    height: -webkit-fill-available;
    justify-content: space-between;
    display: flex;
    flex-direction: column;
    background-color: #ee7155;
  }

  .layout > * {
    margin-top: 2rem;
  }

  h1 {
    font-weight: bold;
    margin-bottom: 1.5rem;
    text-transform: uppercase;
  }

  h2 {
    font-weight: 500;
    margin-bottom: 1em;
  }

  p {
    margin-bottom: 1rem;
  }

  button {
    padding: 0.3rem 0.5rem;
    cursor: pointer;
    background: transparent;
    color: whitesmoke;
  }

  .go-back {
    border-radius: 5px;
    background-color: #1d3336;
    width: fit-content;
    width: -moz-fit-content; 
    width: -webkit-fit-content; 
  }

  .pre-formatted {
    white-space: pre;
  }

  .instruction {
    font-weight: 800;
  }

</style>
